import { dataSourceTypes } from "@/enums/common";

const getters={
  getApiBaseUrl:(state)=>state.apiBaseUrl,
  getServerlessApiBaseUrl:(state)=>state.serverlessApiBaseUrl,
  getClients: (state) => state.clients,
  getActiveClient: (state) => state.activeClient,
  getActiveClientID: (state) => state.generalLocalStorageVariables.activeClientID,
  getActiveUserRole: (state) => state.generalLocalStorageVariables.userRole,
  getAnalyticsGoals:(state)=>state.analyticsGoals,
  getIntegrationsStatus: (state) => {
    return state.integrations.reduce((integrations, integration) => {

      const dataSourceTypeKeyName = Object.keys(dataSourceTypes).find(key => integration.dataSourceType == dataSourceTypes[key]);

      return {
        ...integrations,
        [dataSourceTypeKeyName]: integration.status,
      }

    }, {});
  },
  getIntegrationsValues: (state) => {
    return state.integrations.reduce((integrations, integration) => {

      const dataSourceTypeKeyName = Object.keys(dataSourceTypes).find(key => integration.dataSourceType == dataSourceTypes[key]);

      return {
        ...integrations,
        [dataSourceTypeKeyName]: integration.value,
      }

    }, {});
  },
  getDataSources: (state) => state.dataSources,
  getNotifications: (state) => state.notifications,
  getPopupData: (state) => state.popups,
  getChartsLoadStates: (state) => state.chartsLoadStates,
  getPopupsLoadStates: (state) => state.popupsLoadStates,
  getLoaderStatus: (state) => state.loaderStatus,
  getApisLoadStates: (state) => state.apisLoadStates,
  getDataSourcesData: (state) => state.dataSourcesData,
  getAxiosCancelToken: (state) => state.axiosCancelToken,
  getAxiosCancelStatusCodes: (state) => state.axiosCancelStatusCodes,
  getLocalStorageValueByKey: (state) => (key) => state.generalLocalStorageVariables[key]
}
export default getters



// WEBPACK FOOTER //
// ./src/store/modules/common/getters.js